import React, { FC, ReactNode } from 'react';
import { NavBar } from '@td-client-frontend/common';
import { Link } from 'react-router-dom';
import { TDHLogo } from '@td-client-frontend/icons';

interface BasicNav {
  children: ReactNode;
  menu: ReactNode;
  logoPath: string;
}

const BasicNav: FC<Partial<BasicNav>> = ({ children, menu, logoPath = '/' }) => {
  return (
    <NavBar>
      <div className="flex flex-row h-full space-x-4" data-testid="basic-nav">
        <Link
          className="hover:no-underline h-full flex flex-row justify-center items-center space-x-4 py-3"
          to={logoPath}
        >
          <TDHLogo className="h-full" title="Teladoc Logo on Header Bar" />
          <div className="flex text-center leading-5 h-full justify-center items-center text-primary-500 font-semibold">
            Client Portal
          </div>
        </Link>
        {children}
      </div>
      {menu}
    </NavBar>
  );
};

export default BasicNav;
